// extracted by mini-css-extract-plugin
export var sliderRange = "_of-2";
export var sliderRoot = "_of-0";
export var sliderThumb = "_of-3";
export var sliderTrack = "_of-1";